import React, { Component } from 'react';
import { Icon, Button } from 'semantic-ui-react';
import './CodemirrorSidebar.css';
import axios from 'axios';
import { injectIntl, defineMessages } from 'react-intl';
import { Tooltip } from 'material-ui';
import { Button as Xbutton } from 'components';

class CodemirrorSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      dragStatus: false,
      showImageUrl: null
    };
  }

  componentDidMount() {
    this.props.setNameRef(this.nameRef);
  }

  handleFile = e => {
    if (this.state.dragStatus) this.setState({ dragStatus: false });

    const fileData = e.target.files[0];
    const fileTypeArray = ["image/bmp", "image/jpg", "image/jpeg", "image/png", "image/gif"];
    if(fileData.type && fileTypeArray.indexOf(fileData.type) > -1) {
      this.setState({ file: fileData });
    } else {
      this.setState({ file: null });
    }
  };

  resetFile = () => {
    this.setState({ file: null });
  };

  storeFile = async () => {
    const { file } = this.state;
    const { images } = this.props;

    const formData = new FormData();
    formData.append('name', file.name);
    formData.append('file', file);
    formData.append('phishingNo', this.props.phishingNo);
    try {
      const response = await axios.post('/api/v1/Template/PhishingUploadImage', formData);
      if (!response.data.error) {
        const list = response.data.list;
        const uploadImages = [...images, { imageName: list.imageName, imagePath: list.imagePath, imageNo: list.imageNo }];
        this.props.getImages('upload', uploadImages);
      }
    } catch (err) {
      console.log(err);
    }
    this.setState({
      file: null
    });
  };

  dragEnterHandler = e => {
    this.setState({ dragStatus: true });
  };

  dragLeaveHandler = () => {
    this.setState({ dragStatus: false });
  };

  showImageUrlHandler = index => {
    this.setState({ showImageUrl: index });
  };

  // 업로드한 이미지 삭제 이벤트
  handleDeleteFile = imageNo => {
    this.props.getImages('delete', this.props.images.filter(item => item.imageNo !== imageNo));
  };

  render() {
    const {
      phishingLevel,
      setPhishingNameHandler,
      increaseStepHandler,
      decreaseStepHandler,
      setCurrentStepHandler,
      currentStep,
      phishingName,
      isAuth,
      phishingPublic,
      setPublicHandler,
      phishingScreenEnable,
      setScreenHandler,
      phishingInfo,
      images
    } = this.props;
    const { file, dragStatus, showImageUrl } = this.state;
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const stepBtnList = [...Array(phishingLevel)].map((item, index) => {
      return (
        <div
          key={index}
          className={`step-btn ${index === currentStep ? 'active' : ''}`}
          onClick={() => setCurrentStepHandler(index)}>
          {index === 0 ?
            defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_22', defaultMessage: '메일 본문' }))
            : `${defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_23', defaultMessage: '단계' }))} ${index}`}

        </div>
      );
    });

    const imageUrlList = images.length > 0 ? images.map((item, index) => {
      return (
        <div key={index} className="image-list">
          <div
            className={`image-btn ${showImageUrl === index ? 'active' : null}`}
            onClick={() => this.showImageUrlHandler(index)}>
            {showImageUrl === index ? (
              <input
                className="image-source"
                type="text"
                spellCheck="false"
                value={item.imagePath}
                onChange={e => false}
                onBlur={() => this.setState({ showImageUrl: null })}
                autoFocus
              />
            ) : (
                <div className="image-name">{item.imageName}</div>
              )}
          </div>
          <Xbutton
            className={'bt-icon'}
            icon
            title={defineMessages(formatMessage({ id: 'ExamTemplateDelete_3', defaultMessage: '삭 제' }))}
            onClick={() => { this.handleDeleteFile(item.imageNo) }}>
            <Icon name="cancel" />
          </Xbutton>
        </div>
      );
    }) : [];

    return (
      <section className="phishing-template-setting">
        {isAuth === 2 && <div className="set-public">
          <h4 className="sub-title">{defineMessages(formatMessage({ id: 'ExamTemplateEdit_32', defaultMessage: '공개 여부' }))}</h4>
          <div className={'phishing-button-wrap'}>
            <div className={'phishing-button public'}>
              <Button
                onClick={() => setPublicHandler(1)}
                active={phishingPublic === 1}
              >
                <span>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEdit_34', defaultMessage: '공개' }))}
                </span>
              </Button>
            </div>
            <div className={'phishing-button private'}>
              <Button
                onClick={() => setPublicHandler(0)}
                active={phishingPublic === 0}
              >
                <span>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEdit_33', defaultMessage: '비공개' }))}
                </span>
              </Button>
            </div>
          </div>
        </div>}
        <div className="set-title">
          <h4 className="sub-title">
            {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_19', defaultMessage: '피싱 제목' }))}
          </h4>
          <input
            ref={ref => (this.nameRef = ref)}
            type="text"
            placeholder={defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_20', defaultMessage: '제목을 입력하세요.' }))}
            value={phishingName}
            onChange={e => setPhishingNameHandler(e)}
          />
        </div>
        <div className="set-screen">
          <h4 className="sub-title">{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_32', defaultMessage: '결과 화면 사용 여부' }))}</h4>
          <div className={'phishing-button-wrap'}>
            <div className={'phishing-button public'}>
              <Button
                onClick={() => setScreenHandler(1)}
                active={phishingScreenEnable === 1}
              >
                <span>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEdit_94', defaultMessage: '사용' }))}
                </span>
              </Button>
            </div>
            <div className={'phishing-button private'}>
              <Button
                onClick={() => setScreenHandler(0)}
                active={phishingScreenEnable === 0}
              >
                <span>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEdit_95', defaultMessage: '미사용' }))}
                </span>
              </Button>
            </div>
          </div>
        </div>
        <div className="set-steps">
          <h4 className="sub-title">
            {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_21', defaultMessage: '피싱 단계' }))}
          </h4>
          <div className="step-setting-field">
            <input type="number" value={phishingLevel - 1} readOnly min="1" max="5" />
            <div className="up-down-btn">
              <Icon name="caret up" onClick={increaseStepHandler} />
              <Icon name="caret down" onClick={decreaseStepHandler} />
            </div>
          </div>
        </div>
        <div className="template-status">
          {stepBtnList}
          {phishingScreenEnable === 1 &&
            <div
              className={`step-btn ${currentStep === 3 ? 'active' : ''}`}
              onClick={() => setCurrentStepHandler(3)}>
              {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_33', defaultMessage: '결과 화면' }))}
            </div>
          }
        </div>
        <div className="set-file">
          <div className="sub">
            <h4 className="sub-title">
              {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_24', defaultMessage: '이미지 업로드' }))}
            </h4>
            <Tooltip
              className="image-upload-tooltip"
              title={defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_6', defaultMessage: "업로드된 이미지 클릭 시 나타나는 URL을 복사한 후 <img src='복사한 URL'> 형태로 사용" }))}
              placement="top-end"
            >
              <img className="help-icon" src="/img/examStart/btn_qmark.png" />
            </Tooltip>
          </div>
          <form className={dragStatus ? 'active' : null}>
            <div className="file-input">
              {!!file ?
                <label>{this.state.file.name}</label>
                : <label>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_25', defaultMessage: '파일을 선택하세요.' }))}</label>}
              <input
                accept="image/bmp, image/jpg, image/jpeg, image/png, image/gif"
                type="file"
                onDragEnter={this.dragEnterHandler}
                onDragLeave={this.dragLeaveHandler}
                onChange={e => this.handleFile(e)}
              />
            </div>
          </form>
          {!!file && (
            <div className="file-btns">
              <button onClick={this.resetFile}>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_4', defaultMessage: '취 소' }))}</button>
              <button onClick={this.storeFile}>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_26', defaultMessage: '업로드' }))}</button>
            </div>
          )}
        </div>
        <div className="image-status" ref={ref => (this.imageListWrapper = ref)}>
          {imageUrlList}
        </div>
      </section>
    );
  }
}

export default injectIntl(CodemirrorSidebar);



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/phishingTemplateModal/codemirror/codemirrorSidebar/CodemirrorSidebar.js